<div class="cf-dlg">
  <div class="cf-dlg-header">
    <div class="cf-dlg-icon cf-dlg-icon--blue"><mat-icon>swap_vert</mat-icon></div>
    <div class="fdl-header-text">
      <h2 class="cf-dlg-title">Deuda a corto plazo</h2>
      <p class="cf-dlg-subtitle" *ngIf="financiacionPropia.descripcion">{{ financiacionPropia.descripcion }}</p>
    </div>
    <button mat-icon-button class="cf-dlg-close" (click)="closeDialog()" [disabled]="saving" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <app-loading-state *ngIf="!ready" message="Cargando deuda a corto plazo…"></app-loading-state>
  <app-loading-state *ngIf="ready && saving" [message]="savingMessage"></app-loading-state>

  <ng-container *ngIf="ready && !saving && loadError">
    <div class="cf-dlg-body">
      <div class="fdl-alert fdl-alert--error">
        <mat-icon>error</mat-icon>
        <span>No se pudieron cargar los datos de la deuda a corto plazo.</span>
      </div>
    </div>
    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="closeDialog()">Cerrar</button>
      <button mat-flat-button class="cf-dlg-btn-primary" (click)="retry()">
        <mat-icon>refresh</mat-icon> Reintentar
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="ready && !saving && !loadError">
    <div class="cf-dlg-body fdl-body">
      <div class="fdl-summary">
        <div class="fdl-summary__main">
          <div class="fdl-summary__icon"><mat-icon>account_balance</mat-icon></div>
          <div>
            <span class="fdl-summary__label">Importe pendiente</span>
            <span class="fdl-summary__amount">{{ (financiacionPropia.importePendiente || 0) | number:'1.2-2' }} €</span>
            <span class="fdl-summary__hint">Reclasificado a corto plazo {{ totalReclassified | number:'1.2-2' }} €</span>
          </div>
        </div>
      </div>

      <div class="fdl-section">
        <span class="cf-dlg-section__label">
          {{ editing ? 'Editar reclasificación' : 'Nueva reclasificación' }}
          <button *ngIf="editing" type="button" class="fdl-link" (click)="cancelEdit()">Cancelar edición</button>
        </span>

        <div class="fdl-alert fdl-alert--error" *ngIf="saveError">
          <mat-icon>error</mat-icon>
          <span>{{ saveError }}</span>
        </div>

        <div class="fdl-grid">
          <div class="cf-field--required" [class.cf-field--invalid]="submitted && missingDate">
            <app-date [control]="control('fecha')" [config]="{ label: 'Fecha', required: true }"></app-date>
            <div class="cf-field__error" *ngIf="submitted && missingDate"><mat-icon>error</mat-icon> Indica la fecha</div>
          </div>

          <div class="cf-field--required" [class.cf-field--invalid]="submitted && invalidImporte">
            <app-field [control]="control('importe')" [config]="{ label: 'Importe', type: 'number', required: true, inputmode: 'decimal', step: 0.01, suffix: '€' }"></app-field>
            <div class="cf-field__error" *ngIf="submitted && invalidImporte"><mat-icon>error</mat-icon> Indica un importe distinto de cero</div>
          </div>

          <div class="cf-field--required fdl-grid__wide" [class.cf-field--invalid]="submitted && missingConcept">
            <app-field [control]="control('concepto')" [config]="{ label: 'Concepto', type: 'text', required: true, maxLength: 100, hint: conceptoLength + '/100' }"></app-field>
            <div class="cf-field__error" *ngIf="submitted && missingConcept"><mat-icon>error</mat-icon> Indica el concepto</div>
          </div>

          <div class="cf-field--required fdl-grid__wide" [class.cf-field--invalid]="submitted && missingActivity">
            <app-autocomplete [control]="control('activity')" [config]="{ label: 'Actividad', placeholder: 'Seleccionar actividad…', options: activities, required: true, autoSelectSingle: true, strict: true }">
            </app-autocomplete>
            <div class="cf-field__error" *ngIf="submitted && missingActivity"><mat-icon>error</mat-icon> Selecciona la actividad</div>
          </div>
        </div>
      </div>

      <div class="fdl-section">
        <span class="cf-dlg-section__label">Reclasificaciones registradas</span>
        <div class="fdl-rows" *ngIf="dataSource.length; else emptyList">
          <div class="fdl-row" *ngFor="let item of dataSource; trackBy: trackByUid" [class.fdl-row--editing]="editing?.uid === item.uid">
            <div class="fdl-row__main">
              <div class="fdl-row__amount">{{ (item.importe || 0) | number:'1.2-2' }} €</div>
              <div class="fdl-row__meta" [title]="itemConcept(item)">{{ itemConcept(item) || 'Sin concepto' }}{{ item.activitiesName ? ' · ' + item.activitiesName : '' }}</div>
            </div>
            <div class="fdl-row__date">{{ item.fecha | date:'dd/MM/yyyy' }}</div>
            <div class="fdl-row__actions">
              <button mat-icon-button class="fdl-row__btn" (click)="startEdit(item)" title="Editar" aria-label="Editar deuda a corto plazo">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button class="fdl-row__btn fdl-row__btn--danger" (click)="delete(item)" title="Eliminar" aria-label="Eliminar deuda a corto plazo">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <ng-template #emptyList><div class="fdl-empty">Todavía no se ha reclasificado deuda a corto plazo.</div></ng-template>
      </div>
    </div>

    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="closeDialog()">Cerrar</button>
      <button mat-flat-button class="cf-dlg-btn-primary" (click)="pay()" [disabled]="saving">
        <mat-icon>save</mat-icon> {{ editing ? 'Guardar cambios' : 'Crear' }}
      </button>
    </div>
  </ng-container>
</div>
